import { createElement } from 'react';
import { ProFormDependency as OriginalProFormDependency } from '@ant-design/pro-components';
const ProFormDependency = (props) => {
    const { children, ...otherProps } = props;
    console.log('otherProps', otherProps);
    return (createElement(OriginalProFormDependency, { ...otherProps }, (allValues, form) => {
        console.log('OriginalProFormDependency', allValues, form);
        console.log('children', children?.[0]);
        return children?.[0];
    }));
};
export default ProFormDependency;
